module.exports = __webpack_public_path__ + "media/bootstrap-icons/gem-b72ed645.svg";